var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsInt, IsObject, IsString, IsUUID, Min } from 'class-validator';
import { OfficeProductLineItemFullSizeDto } from '../../custom-office-product-line-item/dtos/custom-office-product-line-item.full-size.dto.js';
export class OfficeProductAssignmentLineItemFullSizeDto {
    id;
    createdAt;
    updatedAt;
    officeProductLineItemId;
    officeProductLineItem;
    officeProductAssignmentId;
    /**
     * The office product assignment (excluded to avoid circular dependency)
     */
    officeProductAssignment;
    currentCount;
    maxCount;
    title;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentLineItemFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeProductAssignmentLineItemFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeProductAssignmentLineItemFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentLineItemFullSizeDto.prototype, "officeProductLineItemId", void 0);
__decorate([
    IsObject(),
    Expose(),
    Type(() => OfficeProductLineItemFullSizeDto),
    __metadata("design:type", OfficeProductLineItemFullSizeDto)
], OfficeProductAssignmentLineItemFullSizeDto.prototype, "officeProductLineItem", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentLineItemFullSizeDto.prototype, "officeProductAssignmentId", void 0);
__decorate([
    Exclude(),
    IsObject(),
    __metadata("design:type", Function)
], OfficeProductAssignmentLineItemFullSizeDto.prototype, "officeProductAssignment", void 0);
__decorate([
    IsInt(),
    Min(0),
    Expose(),
    __metadata("design:type", Number)
], OfficeProductAssignmentLineItemFullSizeDto.prototype, "currentCount", void 0);
__decorate([
    IsInt(),
    Min(1),
    Expose(),
    __metadata("design:type", Number)
], OfficeProductAssignmentLineItemFullSizeDto.prototype, "maxCount", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], OfficeProductAssignmentLineItemFullSizeDto.prototype, "title", void 0);
//# sourceMappingURL=office-product-assignment-line-item.full-size.dto.js.map